var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block',[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_vm._v("车辆里程统计")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("车辆里程统计")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0703731c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wuliu/diaodukanban/block1.vue
// module id = null
// module chunks = 